import { useErrorStore } from "@/store/ErrorStore";
import ErrorDisplay from "./ErrorDisplay";

// ---------------------- Component

const GlobalError = () => {
  // --------- Variables / Hooks

  const { error, setError } = useErrorStore();

  // --------- JSX

  if (!error) return null;

  return (
    <div className="fixed inset-0 z-50">
      <ErrorDisplay
        error={error}
        onClose={() => setError(null)}
      />
    </div>
  );
};

export default GlobalError;
